import { useEvaluateInAppQuery } from '../../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService.hooks';
import { useEvaluatePublicQuery } from '../../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsPublicEvaluationService.hooks';

/**
 * Hook to fetch purchase motions from the backend for both in-app and public pages.
 */
export const usePurchaseMotionsUniversal = ({
  productApiName,
  location,
  isInAppAuth,
  skip
}) => {
  var _query$data;
  const inAppQuery = useEvaluateInAppQuery({
    variables: {
      productApiNames: [productApiName],
      locations: [location]
    },
    skip: !isInAppAuth || skip || !productApiName || !location
  });
  const publicQuery = useEvaluatePublicQuery({
    variables: {
      productApiNames: [productApiName],
      locations: [location]
    },
    skip: isInAppAuth || skip || !productApiName || !location
  });
  const query = isInAppAuth ? inAppQuery : publicQuery;
  const purchaseMotions = query.error ? ['TALK_TO_SALES_FALLBACK'] : ((_query$data = query.data) === null || _query$data === void 0 || (_query$data = _query$data.purchaseMotionsMapping.productsByLocationString[location]) === null || _query$data === void 0 ? void 0 : _query$data.purchaseMotionsByProductApiName[productApiName].purchaseMotions) || ['TALK_TO_SALES_FALLBACK'];
  return {
    purchaseMotions,
    loading: query.loading,
    error: query.error
  };
};